import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import { SubscriptionModel } from '../interfaces';
import { SubscriptionProduct } from '../interfaces.enums';
import { GET_SUBSCRIPTIONS } from './subscriptions.graphql';

export interface OrderedSubscription {
  subscription: SubscriptionModel;
  level: number;
}

const productOrder: (SubscriptionProduct | null)[] = [SubscriptionProduct.BFS, SubscriptionProduct.BVN, null];

export function inReportOrder(subscriptions: SubscriptionModel[]): OrderedSubscription[] {
  const byId = [...subscriptions].sort((a, b) => a.bksId - b.bksId);
  const ordered: OrderedSubscription[] = [];
  const add = (subscription: SubscriptionModel, level: number) => {
    ordered.push({ subscription, level });
    byId.filter((x) => x.parentId === subscription.bksId).forEach((part) => add(part, level + 1));
  };
  for (const product of productOrder) {
    byId.filter((x) => x.parentId == null && (x.product ?? null) === product).forEach((top) => add(top, 0));
  }
  return ordered;
}

export const shortName = (subscription: SubscriptionModel) => subscription.number ?? subscription.name;

export function useReportSubscriptions() {
  const { data } = useQuery<{ subscriptions: SubscriptionModel[] }>(GET_SUBSCRIPTIONS);
  // Kept stable between renders, so tables can memoise on it.
  return useMemo(() => {
    const names = new Map(data?.subscriptions.map((x) => [x.bksId, shortName(x)]));
    return {
      ordered: data ? inReportOrder(data.subscriptions) : undefined,
      shortNameOf: (subscriptionId: number) => names.get(subscriptionId) ?? String(subscriptionId),
    };
  }, [data]);
}
